import React from 'react';
import { Typography } from 'fronton-react';
import { FaqItem } from './faq-item';
import { FaqSection } from './styles';
import { faqItems, title } from './constants';

export const Faq = () => (
	<FaqSection>
		<Typography as="h2" variant="h2">
			{title}
		</Typography>
		{faqItems.map(item => (
			<FaqItem key={item.title} title={item.title}>
				{item.content}
			</FaqItem>
		))}
	</FaqSection>
);
